export default __webpack_public_path__ + "static/media/removeFavorite.2c397c62.svg";